// extracted by mini-css-extract-plugin
export default {"previewTip":"auxvCiamQmK5RfLKC1fMb"};